// Leichtgewichtiges Web-Traffic-Tracking direkt an PostHogs Capture-Endpoint.
// Bewusst OHNE posthog-js: Emergent injiziert bereits eine eigene posthog-js-
// Instanz (window.posthog -> Emergent-Projekt). Eine zweite SDK-Instanz auf
// derselben Seite kollidiert und verwirft Events. Ein direkter Capture-Call an
// unser Projekt (REACT_APP_POSTHOG_KEY) ist konfliktfrei und voll in unserer
// Kontrolle. GeoIP wird serverseitig von PostHog anhand der Client-IP ergänzt.

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = (process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com").replace(/\/$/, "");

export const analyticsEnabled = Boolean(KEY);

const DISTINCT_KEY = "mw_ph_distinct";
const SESSION_KEY = "mw_ph_session";
const SESSION_TS = "mw_ph_session_ts";
const SESSION_MAX_MS = 30 * 60 * 1000;

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function distinctId() {
  let id = localStorage.getItem(DISTINCT_KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(DISTINCT_KEY, id);
  }
  return id;
}

function sessionId() {
  const now = Date.now();
  const last = Number(localStorage.getItem(SESSION_TS) || 0);
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid || now - last > SESSION_MAX_MS) {
    sid = uuid();
    localStorage.setItem(SESSION_KEY, sid);
  }
  localStorage.setItem(SESSION_TS, String(now));
  return sid;
}

function parseUA() {
  const ua = navigator.userAgent || "";
  let os = "Unbekannt";
  if (/windows/i.test(ua)) os = "Windows";
  else if (/iphone|ipad|ipod/i.test(ua)) os = "iOS";
  else if (/mac os x|macintosh/i.test(ua)) os = "Mac OS";
  else if (/android/i.test(ua)) os = "Android";
  else if (/linux/i.test(ua)) os = "Linux";
  let browser = "Unbekannt";
  if (/edg\//i.test(ua)) browser = "Edge";
  else if (/chrome|crios/i.test(ua)) browser = "Chrome";
  else if (/firefox|fxios/i.test(ua)) browser = "Firefox";
  else if (/safari/i.test(ua)) browser = "Safari";
  const device = /mobile|iphone|android/i.test(ua) ? "Mobile" : "Desktop";
  return { os, browser, device };
}

// Kept for import compatibility; capture is stateless so nothing to init.
export function initAnalytics() {}

function send(event, extraProps) {
  if (!KEY || typeof window === "undefined") return;
  try {
    const ref = document.referrer || "";
    let refDomain = "$direct";
    if (ref) {
      try {
        refDomain = new URL(ref).hostname;
      } catch {
        refDomain = "$direct";
      }
    }
    const { os, browser, device } = parseUA();
    const body = {
      api_key: KEY,
      event,
      distinct_id: distinctId(),
      timestamp: new Date().toISOString(),
      properties: {
        $current_url: window.location.href,
        $host: window.location.host,
        $pathname: window.location.pathname,
        $referrer: ref || "$direct",
        $referring_domain: refDomain,
        $session_id: sessionId(),
        $os_name: os,
        $browser: browser,
        $device_type: device,
        $lib: "mw-web",
        ...(extraProps || {}),
      },
    };
    fetch(`${HOST}/capture/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
      credentials: "omit",
    }).catch(() => {});
  } catch {
    /* tracking darf die App nie brechen */
  }
}

// Seitenaufruf (Besuch) — gefeuert pro Routenwechsel.
export function capturePageview() {
  send("$pageview");
}

// Benanntes Event (z.B. smart_redirect_click) — teilt die distinct_id des
// Besuchs, sodass PostHog einen Funnel Besuch → Store-Hop bilden kann.
export function captureEvent(event, properties) {
  send(event, properties);
}

